import skokka from "./skokka";
import axios from "axios";

const SkokkaPlugin = (function () {
  function install(app) {
    app.config.globalProperties.$skokka = skokka;

    axios.defaults.headers.common["X-Requested-With"] = "XMLHttpRequest";

    app.config.globalProperties.$http = axios;
    
    if (typeof window !== "undefined") {
      window.$skokka = skokka;
      window.$http = axios;
    }
  }

  return { install };
})();

export default SkokkaPlugin;
